import React from 'react';
import GooglePlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';
import {MapView} from '../cardComponents/mapView';

/**
 * Display to show / select the Location of the user (relevant to find nearby services / distances)
 * Uses Google Maps API for the maps component
 * @param {*} props 
 * @author BrianCastor
 */
export default function LocationSelector(props) {
  const [error, setError] = React.useState('');
  const [selectedAddress, setSelectedAddress] = React.useState('');
  const [latitude, setLatitude] = React.useState(props.userData['Location__c'] || {});

  function handleSelectedAddressChange(newVal) {
    geocodeByAddress(newVal.label).then(results => {
      getLatLng(results[0]).then(({ lat, lng }) => {
        let location = {'latitude':lat, 'longitude':lng};
        setLatitude(location);
        structureAddressFields(results[0].address_components, location);
      }).catch(err=> setError(err))
    }).catch(err=>setError(err));

    setSelectedAddress(newVal);
  }

  function structureAddressFields(addressComponents, location) {
    let config = {
      street_number:null,
      route:null,
      locality:null,
      administrative_area_level_1:null,
      country:null,
      postal_code:null
    }
    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    for (const component of addressComponents) {
      const addressType = component.types[0];
      if (addressType in config) {
        config[addressType] = component.long_name;
      }
    }

    let newAddress = {
      'MailingStreet':[config.street_number, config.route].join(' ') || '',
      'MailingCity':config.locality,
      'MailingState':config.administrative_area_level_1,
      'MailingCountry':config.country,
      'MailingPostalCode':config.postal_code,
      'Location__c':location
    }

    props.updateUserData(newAddress);

  }

  return (
    <div>
      <h3>What location would you like to search from?</h3>
      <div style={{color:'red'}}>{error}</div>
      <GooglePlacesAutocomplete
        apiKey='AIzaSyBd8LGEpU6x1Ev4bqetj28O0tuqtkn_ZHU'
        debounce={600}
        minLengthAutocomplete={3}
        onLoadFailed={(error) => setError(error.toString())}
        
        selectProps={{
          selectedAddress,
          onChange: (newVal) => handleSelectedAddressChange(newVal),
        }}
        
        //Restrict to only full addresses
        //https://tintef.github.io/react-google-places-autocomplete/docs/props
        //https://developers.google.com/maps/documentation/places/web-service/supported_types#table3
        autocompletionRequest={{
          types:['address']
        }}
      />
      <MapView coordinates={latitude}/>
    </div>
  );
}